module.exports = __webpack_public_path__ + "static/media/1.16412732.jpg";